import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";
import {
  CheckBarcodeAvailabilityRequestBody,
  CheckBarcodeAvailabilityResponse
} from "./checkBarcodeAvailability.types";

export const requestCheckBarcodeAvailability = async (
  body: CheckBarcodeAvailabilityRequestBody
): Promise<CheckBarcodeAvailabilityResponse> => {
  return await instance.post(ApiRoutesProducts.CheckBarcodeAvailability, body);
};
